/* eslint-disable import/no-named-as-default */
import classNames from 'classnames';
import { useMemo } from 'react';

import { useWindowSize } from '@/hooks/index';

import GoogleMaps from '../GoogleMaps/GoogleMaps';

import styles from './AvailableArea.module.scss';

const AvailableArea = ({ data }) => {
  const [windowsX] = useWindowSize();
  const zoom = useMemo(() => {
    if (windowsX < 768) {
      return 13;
    }
    if (windowsX < 1024) {
      return 14;
    }
    return 14;
  }, [windowsX]);

  return (
    <section
      id='available-areas'
      className={classNames(styles.container, 'wrapper section')}
      itemScope
      itemType='https://schema.org/Place'
    >
      <div className={classNames(styles.areaList)}>
        <div className={styles.areaListContent}>
          <div className={styles.areaListIconMobile}>
            <h3>{data?.title}</h3>
          </div>
          <ul className={styles.list}>
            {data?.items?.map((area) => (
              <li
                key={area?.id}
                className={styles.item}
                itemScope
                itemType='https://schema.org/Place'
              >
                {area?.title}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div
        className={classNames(styles.map, 'available-area__card')}
        itemScope
        itemType='https://schema.org/GeoCoordinates'
      >
        <GoogleMaps
          className={styles.five_g_map}
          customCenter={{
            lat: data?.map_center_lat,
            lng: data?.map_center_lng,
          }}
          customOptions={{
            minZoom: 4,
            maxZoom: zoom,
            panControl: true,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            clickableIcons: false,
            keyboardShortcuts: false,
            scrollWeel: false,
            disableDoubleClickZoom: false,
            fullscreenControl: true,
          }}
          markers={data?.items?.map(({ lat, lng }) => ({ lat, lng }))}
          customPin={data?.map_pin_icon}
          disableMarkerClick
          withoutInfoWindow
        />
      </div>
    </section>
  );
};

export default AvailableArea;
